import styled from '@emotion/styled'
import {
  FormElement,
  HelpIcon,
  Select,
  SELECT_VARIANT_WITH_CHECKBOX,
  SPACING_4,
  SpacingVertical,
  Text,
  TEXT_VARIANT_BOLD,
  TEXT_VARIANT_BOLD_LIGHT,
  TooltipUtils
} from 'mailup-web-components'
import { addNewTagCallback } from 'Pages/Task/recoil/callbacks/callbacks'
import { tagsListState, taskState } from 'Pages/Task/recoil/state/task'
import PropTypes from 'prop-types'
import { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useRecoilCallback, useRecoilState, useRecoilValue } from 'recoil'

const StyledHelpIcon = styled(HelpIcon)`
  svg {
    top: 2px !important;
  }
`

const InputTags = ({ idDisabled }) => {
  const intl = useIntl()

  const makeOption = (e) => ({
    label: `${e.Name}`,
    value: e.Id,
    disabled: !e.Enabled
  })
  const addTagCallback = useRecoilCallback(addNewTagCallback, [])
  const { tagsList } = useRecoilValue(tagsListState)
  const [{ Tags }, setTaskState] = useRecoilState(taskState)

  const options = tagsList.map(makeOption)

  useEffect(() => {
    setTimeout(() => TooltipUtils.rebuild(), 5000)
  }, [tagsList])

  const props = () => ({
    disabled: idDisabled,
    placeholder: intl.formatMessage({ id: 'Load.TagSelector.lblSelectTags' }),
    hint:
      (Tags.length === options.length &&
        intl.formatMessage({ id: 'Load.Common.NoMoreOptions' })) ||
      null,
    onChange: (value) => {
      setTaskState((prev) => ({
        ...prev,
        Tags: value,
        isDirty: true
      }))
    }
  })

  const handleSubmit = (e) => {
    const exist = tagsList.find((t) => t.Name === e)
    if (!exist) {
      addTagCallback(e)
    }
  }

  return (
    <FormElement>
      <Text
        htmlElement='span'
        variant={idDisabled ? TEXT_VARIANT_BOLD_LIGHT : TEXT_VARIANT_BOLD}
      >
        {intl.formatMessage({ id: 'Load.Common.Tag' })}
      </Text>

      <span data-tip data-for='customSenderTooltip'>
        <StyledHelpIcon />
      </span>
      <div>
        <TooltipUtils
          id='customSenderTooltip'
          type='light'
          effect='solid'
          className='c-tooltip'
        >
          {intl.formatMessage(
            {
              id: 'Load.Task.GeneralTagTooltip'
            },
            {
              linebreak: <br />,
              strong: (chunk) => <strong>{chunk}</strong>
            }
          )}
        </TooltipUtils>
      </div>

      <SpacingVertical variant={SPACING_4} />
      <Select
        variant={SELECT_VARIANT_WITH_CHECKBOX}
        options={options}
        {...props()}
        multiple
        disabled={idDisabled}
        value={Tags}
        onSubmit={handleSubmit}
        data-mu-test='select-tags'
        placeholder={intl.formatMessage({
          id: 'Load.TagSelector.lblSelectTags'
        })}
      />
    </FormElement>
  )
}

InputTags.propTypes = {
  idDisabled: PropTypes.bool
}

export default InputTags
